import React, { FC } from 'react';
import { Input, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { useGetApplication } from '~/controllers/wizard';

import { Collapse, DocumentInput, Form } from '~/components';
import buildNamePath from '~/utils/buildNamePath';
import { Person } from '~/types/Person';
import styled from 'styled-components';
import InputsGroupLayout from '~/layouts/InputsGroupLayout';

const AdditionalDocuments: FC = () => {
  const { t } = useTranslation('ksaApplication');
  const applicationQuery = useGetApplication();

  if (!applicationQuery.data) {
    return null;
  }

  const isVisible = !!applicationQuery.data.payload?.additionalDocumentsAreRequired;

  return (
    <Form.Visible<Person[] | undefined> name={['companyInformation']} visibleIf={() => isVisible}>
      <Container>
        <Typography.Title level={4}>{t('Additional documents').toUpperCase()}</Typography.Title>
        <Collapse className="AdditionalDocuments-Collapse" defaultActiveKey={['0', '1', '2']} ghost>
          <Collapse.Panel header={t('Sama license').toUpperCase()} key="0">
            <Typography.Paragraph>{t('Please upload the SAMA license photo')}</Typography.Paragraph>
            <Form.Item name={n([samaLicenseName, 'files'])}>
              <DocumentInput name="photos" variant="default" />
            </Form.Item>
            <InputsGroupLayout>
              <div>
                <Typography.Text className="AdditionalDocuments-DocumentTitle">
                  {t('Document number:')}
                </Typography.Text>
                <Form.Item
                  name={n([samaLicenseName, 'documentNumber'])}
                  label={t('License number')}
                >
                  <Input />
                </Form.Item>
              </div>
            </InputsGroupLayout>
          </Collapse.Panel>
          <Collapse.Panel header={t('AML policy and procedure').toUpperCase()} key="1">
            <Typography.Paragraph>
              {t('Please upload the AML policy and procedure document')}
            </Typography.Paragraph>
            <Form.Item name={n([amlPolicyName, 'files'])}>
              <DocumentInput name="photos" variant="default" />
            </Form.Item>
            <InputsGroupLayout>
              <div>
                <Typography.Text className="AdditionalDocuments-DocumentTitle">
                  {t('Document number:')}
                </Typography.Text>
                <Form.Item name={n([amlPolicyName, 'documentNumber'])} label={t('Document number')}>
                  <Input />
                </Form.Item>
              </div>
            </InputsGroupLayout>
          </Collapse.Panel>
          <Collapse.Panel header={t('Compliance Clearance Certificate').toUpperCase()} key="2">
            <Typography.Paragraph>
              {t('Please upload the Compliance Clearance Certificate')}
            </Typography.Paragraph>
            <Form.Item name={n([complianceClearanceCertificateName, 'files'])}>
              <DocumentInput name="photos" variant="default" />
            </Form.Item>
            <InputsGroupLayout>
              <div>
                <Typography.Text className="AdditionalDocuments-DocumentTitle">
                  {t('Document number:')}
                </Typography.Text>
                <Form.Item
                  name={n([complianceClearanceCertificateName, 'documentNumber'])}
                  label={t('Document number')}
                >
                  <Input />
                </Form.Item>
              </div>
            </InputsGroupLayout>
          </Collapse.Panel>
        </Collapse>
      </Container>
    </Form.Visible>
  );
};

const Container = styled.div`
  .AdditionalDocuments-Collapse {
    margin: -16px;
    margin-bottom: 32px;
  }

  .AdditionalDocuments-DocumentTitle {
    display: block;
    font-weight: 500;
    margin-bottom: 16px;
  }
`;

export const samaLicenseName = 'samaLicense';
export const complianceClearanceCertificateName = 'complianceClearanceCertificate';
export const amlPolicyName = 'amlPolicy';
const n = buildNamePath('companyQuestionnaire');

export default AdditionalDocuments;
